var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg18PlusRing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.2,17.4v-7.1H6.6V8.5h3.9v8.9H8.2L8.2,17.4z M14.5,11c0,0.6,0.5,1,1.3,1c0.8,0,1.3-0.4,1.3-1 c0-0.7-0.5-1-1.3-1C15,9.9,14.5,10.3,14.5,11 M14.3,14.7c0,0.7,0.5,1.2,1.5,1.2c1,0,1.5-0.4,1.5-1.2c0-0.7-0.5-1.2-1.5-1.2 C14.8,13.6,14.3,14,14.3,14.7 M18.9,10.8c0,0.8-0.4,1.5-1.1,1.8c1,0.4,1.6,1.3,1.6,2.2c0,1.6-1.4,2.6-3.6,2.6s-3.6-1-3.6-2.6 c0-1,0.7-1.9,1.7-2.3c-0.7-0.4-1.2-1.1-1.2-1.9c0-1.4,1.2-2.3,3.2-2.3C17.7,8.5,18.9,9.4,18.9,10.8 M23.2,9.6 c0.4,1.1,0.6,2.3,0.6,3.4c0,5.9-4.8,10.7-10.7,10.7S2.3,18.9,2.3,13S7.1,2.3,13,2.3c1.2,0,2.3,0.2,3.4,0.6V0.4C15.3,0.1,14.2,0,13,0 C5.8,0,0,5.8,0,13s5.8,13,13,13s13-5.8,13-13c0-1.2-0.1-2.3-0.5-3.4H23.2z M22.5,3.5V1h-1.8v2.5h-2.5v1.8h2.5v2.5h1.8V5.3H25V3.5 L22.5,3.5L22.5,3.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18PlusRing);
export default __webpack_public_path__ + "static/media/18-plus-ring.27272926c6718f0be37c88b760575c19.svg";
export { ForwardRef as ReactComponent };